// Generic function to upsert (update or insert) an item into an array based on a unique key.
function upsert<T, K extends keyof T>(
  array: T[],    // The original array of objects
  newItem: T,     // The new item to be inserted or updated
  key: K,         // The unique key used to identify the item in the array
): T[] {
  // Find the index of the item in the array that matches the new item's key value.
  const index = array.findIndex(item => item[key] === newItem[key]);

  if (index !== -1) {
    // If the item already exists, update the existing object with the new item.
    array[index] = newItem;
  } else {
    // If the item does not exist, append the new item to the array.
    array.push(newItem);
  }

  // Return a new array with the updated or newly added item.
  return [...array];
}

// Exporting the upsert function as a utility under the ArrayHelper object.
export const ArrayHelper = {
  Upsert: upsert
};
